import React from "react";
import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Button } from "Components/Button";
import { Box } from "styles/globalComponents";
import { useHistory, useParams } from "react-router";
import { MaskCPF } from "Utils/Masks";
import { Loader } from "Components/Loader";
import { PageContainer, PageContent, PageHeading } from "./styles";
import { ChooseProducts } from "./components/Steps/ProductsCheckout";
import { CartDetails } from "./components/Cart";
import { ItemsProvider } from "./Provider";
import { usePreOrderDetails } from "./hooks/usePreOrderDetails";

const ConvertPreOrder = () => {
  const { id } = useParams<{ id: string }>();

  const preOderDetailsAPI = usePreOrderDetails(Number(id));

  const history = useHistory();

  const moveToPreOrderListPage = () => history.push("/listagem-pre-pedido");

  if (preOderDetailsAPI.error) {
    return (
      <PageContainer className="entry-app-content entry-budget">
        <PageContent className="content-holderpage-budget">
          <Box display="flex" justify="center" className="edit-blocked">
            <h3 className="text-center">
              O pré-orçamento está bloqueado para edição no momento, pois outro
              usuário já está editando este pré-orçamento.
            </h3>
          </Box>
        </PageContent>
      </PageContainer>
    );
  }

  if (!id) {
    return (
      <PageContainer className="entry-app-content entry-budget">
        <PageContent className="content-holderpage-budget">
          <Box mt="200" display="flex" align="center" direction="column">
            <h3 className="text-center">
              Converta um pré-orçamento a partir da listagem de pré-orçamentos.
            </h3>
            <Button onClick={moveToPreOrderListPage}>Acessar listagem</Button>
          </Box>
        </PageContent>
      </PageContainer>
    );
  }

  if (preOderDetailsAPI.isLoading) {
    return (
      <PageContainer className="entry-app-content entry-budget">
        <PageContent className="content-holderpage-budget">
          <Box
            display="flex"
            align="center"
            className="edit-blocked"
            justify="center"
            direction="column"
          >
            <h3 className="text-center">
              Carregando detalhes do pré-orçamento, aguarde !
            </h3>
            <Loader />
          </Box>
        </PageContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer className="entry-app-content entry-budget">
      <PageContent className="content-holderpage-budget">
        <PageHeading className="page-heading">
          <div className="wrapper-header-content m-bottom-1 order-budget">
            <PageHeader title="Conversão pré-orçamento" isBudget>
              <Breadcrumb
                list={[
                  {
                    path: "",
                    label: "Pré-orçamento",
                    current: false,
                  },

                  {
                    path: "#",
                    label: "Adicionar produtos",
                    current: true,
                  },
                ]}
              />
            </PageHeader>

            <div className="budget-header-user">
              <h5>Convertendo em orçamento para:</h5>
              <p>{preOderDetailsAPI.data?.full_name || "Não informado"}</p>
              <p>
                {MaskCPF(preOderDetailsAPI.data?.document) || "Não informado"}{" "}
              </p>
            </div>
          </div>
        </PageHeading>

        <ItemsProvider>
          <>
            <ChooseProducts />

            <CartDetails />
          </>
        </ItemsProvider>
      </PageContent>
    </PageContainer>
  );
};

export default ConvertPreOrder;
